import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Block, Inline, CRIcon } from '../crRender'
import { validateImg } from '../../utils'
import './style.css'

const EditableImage = ({ 
    label, 
    defaultValue, 
    formHandler, 
    name, 
    isRequired = false,
    className = "col-md-6",
}) => {
    const { t } = useTranslation()
    const { formValues, handleFormValues } = formHandler
    const [currentImage, setCurrentImage] = useState(defaultValue)
    const [newImageFile, setNewImageFile] = useState(null)
    const [imagePreview, setImagePreview] = useState(null)
    const fileInputRef = useRef(null)

    useEffect(() => {
        setCurrentImage(defaultValue)
        if (defaultValue) {
            setImagePreview(null)
        }
    }, [defaultValue])

    useEffect(() => {
        if (newImageFile) {
            if (validateImg(newImageFile)) {
                const reader = new FileReader()
                reader.onloadend = () => {
                    setImagePreview(reader.result)
                }
                reader.readAsDataURL(newImageFile)
                handleFormValues(name, {
                    value: newImageFile,
                    isRequired,
                    isError: false
                })
            } else {
                handleFormValues(name, {
                    value: null,
                    isRequired,
                    isError: true
                })
            }
        } else if (currentImage) {
            handleFormValues(name, {
                value: currentImage,
                isRequired,
                isError: false
            })
        }
    }, [newImageFile, currentImage])

    const handleFileChange = (file) => {
        if (file && validateImg(file)) {
            setNewImageFile(file)
            setCurrentImage(null)
        } else {
            setNewImageFile(null)
        }
    }

    const handleRemoveImage = () => {
        setCurrentImage(null)
        setNewImageFile(null)
        setImagePreview(null)
        if (fileInputRef.current) {
            fileInputRef.current.value = ""
        }
        handleFormValues(name, {
            value: null,
            isRequired,
            isError: false
        })
    }

    const handleEditClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }



    const displayImage = imagePreview || currentImage

    return (
        <div className={`form-group editable-image-container ${className}`}>
            <Block isRender={label}>
                <label>
                    {t(label)}
                    <Inline isRender={isRequired} className={"required"}>*</Inline>
                </label>
            </Block>

            <div className="editable-image-wrapper">
                {displayImage ? (
                    <div className="image-preview-container">
                        <img 
                            src={displayImage} 
                            alt={label || "Image"} 
                            className="editable-image-preview"
                        />
                        <div className="image-overlay">
                            <button
                                type="button"
                                className="edit-image-btn"
                                onClick={handleEditClick}
                                title={t("edit")}
                            >
                                <CRIcon icon="mdi:pencil" />
                            </button>
                            <button
                                type="button"
                                className="remove-image-btn"
                                onClick={handleRemoveImage}
                                title={t("delete")}
                            >
                                <CRIcon icon="mdi:delete" />
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="no-image-container">
                        <CRIcon icon="mdi:image-outline" className="placeholder-icon" />
                        <button
                            type="button"
                            className="upload-image-btn"
                            onClick={handleEditClick}
                        >
                            {t("upload-image")}
                        </button>
                    </div>
                )}
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e.target.files[0])}
                    style={{ display: 'none' }}
                />
            </div>

            {formValues[name]?.isError && (
                <span className="error-message">{t("Please enter a valide img")}</span>
            )}
        </div>
    )
}

export default EditableImage

